import { type PermissionsProps } from '@/services/types/permissions/mockPermissions'
import { api } from './api'
import { endpoints } from './endpoints'

export const permissionsService = {
  async getPermissions() {
    return api.get<PermissionsProps>(endpoints.roles.permissions)
  },
}
